module.exports = __webpack_public_path__ + "static/media/lobby-card-plenary-hall.0fdfc4fd.svg";